import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm, UseFormSetError } from "react-hook-form";
import { INavigation } from "../../types/interface";
import { navigationValidation } from "../../utils/validationSchema";
import ComponentForm from "./Form";

interface Props {
  handleUpdate: (
    data: INavigation,
    setError: UseFormSetError<INavigation>
  ) => Promise<void>;
  isUpdatingNavigation: boolean;
  navigationInfo: INavigation;
}

export default function UpdateNavigation({
  handleUpdate,
  isUpdatingNavigation,
  navigationInfo,
}: Props) {
  const updateNavigationMethods = useForm<INavigation>({
    defaultValues: { ...navigationInfo },
    resolver: yupResolver(navigationValidation),
  });

  return (
    <>
      <FormLayout
        isLoading={isUpdatingNavigation}
        handleSubmit={updateNavigationMethods.handleSubmit}
        handleFormSubmit={handleUpdate}
        buttonLabel="Udpate"
        disabled={isUpdatingNavigation}
        setError={updateNavigationMethods.setError}
      >
        <FormProvider {...updateNavigationMethods}>
          <ComponentForm />
        </FormProvider>
      </FormLayout>
    </>
  );
}
